// extracted by mini-css-extract-plugin
export default {"boldText":"bold-text_boldText__3cCIw"};